import { FC, useMemo, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import { CriteriaFormMode, CriteriaListItem } from '../../../types/criteria-setting';
import { fetchCriteriaItem } from '../../../network/criteriaCrud';
import CriteriaSettingForm from './components/CriteriaSettingForm';

const CriteriaSettingDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { formMode } = useMemo(
    () => ({
      formMode: id ? CriteriaFormMode.EDIT : CriteriaFormMode.CREATE,
    }),
    [id],
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [criteriaItem, setCriteriaItem] = useState<CriteriaListItem>();

  const reloadData = async () => {
    if (id) {
      setIsLoading(true);
      try {
        const res = await fetchCriteriaItem(id, dispatch);
        setCriteriaItem(res);
      } catch (err) {
        history.push(NOT_FOUND_ERROR_PAGE_PATH);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    reloadData();
  }, [id]);

  return (
    <>
      {formMode === CriteriaFormMode.CREATE && <CriteriaSettingForm formMode={formMode} />}
      {formMode === CriteriaFormMode.EDIT &&
        (isLoading || !criteriaItem ? (
          <LayoutSplashScreen />
        ) : (
          <CriteriaSettingForm formMode={formMode} criteriaItem={criteriaItem} />
        ))}
    </>
  );
};

export default CriteriaSettingDetailPage;
